<!-- 热门策略 -->
<template>
  <div class="Rmcl" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title_t">
      <p class="name">热门策略</p>
      <p @click="clMore">更多<van-icon name="arrow" /></p>
    </div>

    <ul class="list">
      <li @click="goclDetail(item)" v-for="(item, index) in hotTactic" :key="index" class="list_li">
        <div class="tit_box">
          <span class="name">{{ item.s_name }}</span>
          <span :class="[judgeColor(item.RiZhangFu)]" class="zf">{{
            toFixedNum(item.RiZhangFu * 100, 2, '%')
          }}</span>
        </div>

        <div class="intro_box one-txt-cut">
          {{ item.s_desc }}
        </div>

        <ul class="ul_cont">
          <li class="li_box">
            <p :class="item.BestAvgRate | formateRedGreen">
              {{ toFixedNum(item.BestAvgRate * 100, 2, '%') }}
            </p>
            <p>最优涨幅·{{ item.BestAvgCycle }}天</p>
          </li>
          <li class="li_box">
            <p :class="item.MaxRiseRate | formateRedGreen">
              {{ toFixedNum(item.MaxRiseRate * 100, 2, '%') }}
            </p>
            <p>最大概率·{{ item.MaxRiseCycle }}天</p>
          </li>
          <li class="li_box">
            <p>{{ item.XinHaoShuLiang }}只</p>
            <p>今日信号</p>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { getHotTactics, getFactorHq } from '@/api/index.js';

import { judgeColor, toFixedNum,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';

export default {
  name: 'Rmcl',
  mixins: [mixin],
  props: [],

  data() {
    return {
      hotTactic: [],
      hotTacticInterval: null,
      isVip: false
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    this.getHotTactic();
  },
  beforeDestroy() {
    // window.clearInterval(this.hotTacticInterval);
    // this.hotTacticInterval = null;
  },
  methods: {
    judgeColor,
    toFixedNum,
    compareVersions,

    // 获取热门策略接口数据
    getHotTactic: function () {
      let _this = this;
      let obj = {
        type: 'all',
        limit: 5,
        type_info: compareVersions(_this.$route.query.version , 9.69)  ? 0 : 1 //0全部  1A股 2ETF
      };
      getHotTactics(obj)
        .then((res) => {
          _this.$toast.clear();
          if (res.err === 200 && res.data.length > 0) {
            let idKeys = res.data.map((item) => {
              return item.f_id_arr.replaceAll(',', '_');
            });
            idKeys = idKeys.toString();
            _this.getHqData(idKeys, res.data);
            // _this.hotTacticInterval = window.setInterval(() => {
            //   _this.getHqData(idKeys, res.data);
            // }, 60000);
          }
        })
        .catch(() => {
          _this.$toast.clear();
        });
    },

    // 获取行情数据
    getHqData: function (idKeys, data) {
      let _this = this;
      let obj = {
        type: 'cl',
        groupID: idKeys,
        field: 'Desc'
      };
      getFactorHq(obj).then((res) => {
        if (res.err === 200) {
          const mergedArr = data.map((item1) => {
            const item2 = res.data.find((item) => item.ID == item1.f_id_arr.replaceAll(',', '_'));
            return {
              ...item1,
              RiZhangFu: item2.RiZhangFu,
              ID: item2.ID,
              XinHaoShuLiang: item2.XinHaoShuLiang
            };
          });
          _this.hotTactic = mergedArr;
        } else {
          _this.hotTactic = data;
        }
      });
    },

    // 策略更多
    clMore: function () {
      location.href = '/hot?DZHSPECIAL=4325641&navId=0';
    },

    // 跳转策略详情
    goclDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) ) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0703'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/clDetail?DZHSPECIAL=4325641&type=hot&s_id=' + item.s_id;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.Rmcl {
  padding: 0 0 0 16px;
  margin-top: 30px;
  .title_t {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;
    padding-right: 16px;
    .name {
      display: flex;
      align-items: center;
      ::v-deep {
        .van-icon-question-o {
          margin-left: 5px;
          margin-top: 2px;
        }
      }
    }
    p {
      color: #222;
      &:first-child {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
      }
      &:last-child {
        border-radius: 10px;
        background: #f7f8fa;
        padding: 3px 6px 3px 10px;
        font-size: 10px;
        font-weight: 500;
      }
    }
  }

  .list {
    display: flex;
    overflow-x: auto;
    .list_li {
      border-radius: 8px;
      border: 1px solid #e5e5e5;
      width: 300px;
      padding: 8px 12px;
      background: #f9fafb;
      flex-shrink: 0;
      margin-right: 10px;
      margin-bottom: 2px;

      .tit_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          color: #555;
          font-size: 16px;
          font-weight: 500;
        }
        .zf {
          font-size: 16px;
          font-weight: 600;
        }
      }

      .intro_box {
        color: #999;
        font-size: 12px;
        margin-top: 4px;
      }

      .ul_cont {
        display: flex;
        justify-content: space-between;
        border-radius: 4px;
        background: #fff;
        margin-top: 8px;
        padding: 12px;
        text-align: center;
        .li_box {
          p {
            &:first-child {
              font-size: 14px;
              font-weight: 600;
            }
            &:last-child {
              color: #999;
              font-size: 12px;
              font-weight: 400;
              margin-top: 4px;
            }
          }
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title_t {
    p {
      &:first-child {
        color: #e4e9fe;
      }
      &:last-child {
        background: #1d202d;
        color: #e4e9fe;
      }
    }
  }
  .list {
    .list_li {
      border: 1px solid #353a50;
      background: #272935;
      .tit_box {
        .name {
          color: #aab9d1;
        }
      }
      .intro_box {
        color: #aab9d1;
      }

      .ul_cont {
        background: #2d2f3b;
        .li_box {
          p {
            &:first-child {
              color: #e4e9fe;
            }
            &:last-child {
              color: #aab9d1;
            }
          }
        }
      }
    }
  }
}
</style>
